import { gql, useQuery } from '@apollo/client'
import { max, isEmpty } from 'lodash'

import { round } from 'utils/math'

export const getComboComponents = (combo: TSFixMe): TSFixMe => {
  return combo.components || combo.comboComponents
}

export const isCombo = ({ item }: TSFixMe): TSFixMe => {
  const components = getComboComponents(item)
  return !isEmpty(components)
}

export const getProductsCountByCombo = (combo: TSFixMe): TSFixMe => {
  if (!isCombo({ item: combo })) {
    return 0
  }

  const components = getComboComponents(combo)

  return components.reduce((result: TSFixMe, component: TSFixMe): TSFixMe => {
    return result + round(combo.quantity * component.quantity)
  }, 0)
}

export const GET_ITEMS_AUTOCOMPLETE = gql`
  query GetItemsAutocomplete($companyId: ID, $includeSims: Boolean) {
    itemsAutocomplete(input: { limit: 10000, companyID: $companyId, includeSims: $includeSims }) {
      id
      name
      netContent
      container
      category
      subcategory
      brand
      units
      isActive
    }
  }
`

export const GET_COMBO_ITEMS_AUTOCOMPLETE = gql`
  query GetComboItemsAutocomplete($companyId: ID) {
    comboItemsAutocomplete(input: { limit: 100000, companyID: $companyId }) {
      id
      name
      category
      subcategory
      isActive
    }
  }
`

export const useSanitizeItem = (itemId: TSFixMe, companyId: TSFixMe): TSFixMe => {
  const { data: itemsData } = useQuery(GET_ITEMS_AUTOCOMPLETE, {
    skip: !itemId,
    variables: {
      limit: 1000,
      companyId
    }
  })

  return itemsData?.itemsAutocomplete?.find(({ id }: TSFixMe): TSFixMe => itemId === id)
}

export const resolvers = {
  Mutation: {
    activateItem(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Item',
          id
        }),
        fragment: gql`
          fragment ItemIsActive on Item {
            isActive
          }
        `,
        data: {
          isActive: true,
          __typename: 'Item'
        }
      })

      return null
    },
    deactivateItem(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Item',
          id
        }),
        fragment: gql`
          fragment ItemIsActive on Item {
            isActive
          }
        `,
        data: {
          isActive: false,
          __typename: 'Item'
        }
      })

      return null
    },
    updateItemStockQuantity(_root: TSFixMe, { quantity, itemId }: TSFixMe, { cache }: TSFixMe) {
      const data = cache.readFragment({
        id: cache.identify({
          __typename: 'InventoryItemResponse',
          id: itemId
        }),
        fragment: gql`
          fragment ItemStockQuantity on InventoryItemResponse {
            stockQuantity
          }
        `
      })

      const newStockQuantity = data.stockQuantity + parseInt(quantity)

      cache.writeFragment({
        id: cache.identify({
          __typename: 'InventoryItemResponse',
          id: itemId
        }),
        fragment: gql`
          fragment ItemStockQuantity on InventoryItemResponse {
            stockQuantity
          }
        `,
        data: {
          __typename: 'InventoryItemResponse',
          stockQuantity: newStockQuantity
        }
      })

      return null
    },
    updateItemLostQuantity(_root: TSFixMe, { quantity, itemId }: TSFixMe, { cache }: TSFixMe) {
      const data = cache.readFragment({
        id: cache.identify({
          __typename: 'InventoryItemResponse',
          id: itemId
        }),
        fragment: gql`
          fragment ItemLostQuantity on InventoryItemResponse {
            stockQuantity
            lostQuantity
          }
        `
      })

      const newStockQuantity = max([data.stockQuantity - parseInt(quantity), 0])
      const newLostQuantity = data.lostQuantity + parseInt(quantity)

      cache.writeFragment({
        id: cache.identify({
          __typename: 'InventoryItemResponse',
          id: itemId
        }),
        fragment: gql`
          fragment ItemLostQuantity on InventoryItemResponse {
            stockQuantity
            lostQuantity
          }
        `,
        data: {
          __typename: 'InventoryItemResponse',
          stockQuantity: newStockQuantity,
          lostQuantity: newLostQuantity
        }
      })

      return null
    },
    activateCombo(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'ComboItem',
          id
        }),
        fragment: gql`
          fragment ComboIsActive on ComboItem {
            isActive
          }
        `,
        data: {
          isActive: true,
          __typename: 'ComboItem'
        }
      })

      return null
    },
    deactivateCombo(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'ComboItem',
          id
        }),
        fragment: gql`
          fragment ComboIsActive on ComboItem {
            isActive
          }
        `,
        data: {
          isActive: false,
          __typename: 'ComboItem'
        }
      })

      return null
    },
    activatePlan(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'KolorsMobilePlanItem',
          id
        }),
        fragment: gql`
          fragment PlanIsActive on KolorsMobilePlanItem {
            isActive
          }
        `,
        data: {
          isActive: true,
          __typename: 'KolorsMobilePlanItem'
        }
      })

      return null
    },
    deactivatePlan(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'KolorsMobilePlanItem',
          id
        }),
        fragment: gql`
          fragment PlanIsActive on KolorsMobilePlanItem {
            isActive
          }
        `,
        data: {
          isActive: false,
          __typename: 'KolorsMobilePlanItem'
        }
      })

      return null
    }
  }
}
